import api from "../api/api"

export default function generateBaseImportFromStage({url = null, isGeoFeature = false}) {
    return {
        state: {
            importLoading: false,
            importDialog: false,
        },
        mutations: {
            TOGGLE_IMPORT_FROM_STAGE_LOADING(state, value) {
                state.importLoading = typeof value === 'undefined' ? !state.importLoading : value;
            },
            TOGGLE_IMPORT_DIALOG(state, value) {
                state.importDialog = typeof value === 'undefined' ? !state.importDialog : value;
            }
        },
        actions: {
            async importFromStage({state}, option = {}) {
                const baseUrl = url || state.baseUrl;
                const importUrl = `${baseUrl}import_from_stage/`;
                const payload = isGeoFeature ? {properties: option} : option;
                const response = await api.post(importUrl, payload);
                return response.data;
            },
            toggleImportDialog({commit}, value) {
                commit('TOGGLE_IMPORT_DIALOG', value);
            }
        }
    };
}
